import ResponseModal from './ResponseModal';
export default ResponseModal;
